import { Folder } from '../../db/Folder';
import { LASFile } from '../../db/LASFile';
import type { MediaUnion } from '../../db/MediaUnion';

export const getMediaTitle = (media: MediaUnion, plain: boolean = false) => {
  if (media instanceof Folder) return FolderTitle(media);
  if (media instanceof LASFile) return LASFileTitle(media, plain);
  return 'invalid media type class';
};

function FolderTitle(media: Folder) {
  return media.name;
}

function LASFileTitle(media: LASFile, plain: boolean) {
  if (plain) return media.meta?.fileName ?? '';
  const extension = media.meta?.extension ?? '';
  return `${media.meta?.fileName}.${extension}`;
}
